define([], function () {
  PDFJS.workerSrc = '/assets/pdf/pdf.worker.js';
  window.pdfDocument = window.pdfDocument || {};

  var stickyBlock = function(){
    var block = $('.pdf-viewer-footer-wrapper');
    var footer_block = $('.footer');
    var scroll = $(window).scrollTop() + $(window).height();
    var footer = footer_block.height();
    var footer_scroll = footer + footer_block.offset().top;

    if ((scroll + footer) > footer_scroll) {
      block.css({
        'position': 'relative',
        'top': 'auto',
        'bottom': 'auto'
      });

    } else {
      block.css({
        'position': 'fixed',
        'bottom': '0',
        'top': 'auto'
      });
    }
  };

  var renderPages = function (pdfDoc, canvasContainer, options) {
    for(var num = 1; num <= pdfDoc.numPages; num++)
      pdfDoc.getPage(num).then(function(page){
        renderPage(page, canvasContainer, options);
      });
    $('.loading-wrapper .ca-loading').remove();
  };

  var renderPage = function (page, canvasContainer, options) {
    var viewport = page.getViewport(options.scale);
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    var renderContext = {
      canvasContext: ctx,
      viewport: viewport
    };

    canvas.height = viewport.height;
    canvas.width = viewport.width;
    canvasContainer.appendChild(canvas);
    page.render(renderContext);
    stickyBlock();
  };

  var renderPDF = function(url, canvasContainer, options) {
    var options = options || { scale: 1.6 };

    PDFJS.disableWorker = true;
    PDFJS.getDocument(url).then(function(res){
      window.pdfDocument.file = res;
      renderPages(res, canvasContainer, options);
    });
    window.pdfDocument.scale = options.scale;

    $(window).scroll(function () {
      stickyBlock();
    });
  };

  var zoomIn = function(canvasContainer){
    if(window.pdfDocument.scale <= 2.5){
      $(canvasContainer).html('');
      window.pdfDocument.scale += 0.1;
      renderPages(window.pdfDocument.file, canvasContainer, { scale: window.pdfDocument.scale });
    }
  };

  var zoomOut = function(canvasContainer){
    if(window.pdfDocument.scale > 0.5){
      $(canvasContainer).html('');
      window.pdfDocument.scale -= 0.1;
      renderPages(window.pdfDocument.file, canvasContainer, { scale: window.pdfDocument.scale });
    }
  };

  return {
    renderPDF: renderPDF,
    zoomIn: zoomIn,
    zoomOut: zoomOut
  };
});
